import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Field, reduxForm} from 'redux-form'
import {Badge, Col, Form, Modal, Row} from "react-bootstrap"
import {CheckboxField, DateField, SelectField, TextareaField, TextField} from '../form/form'
import {connect} from "react-redux";
import {showMessage} from '../../actions';
import {defaultState} from '../../reducers/entity';
import {BaseStatus, DEFAULT_CONTRACT_LOCATION, ExitPartyLabel, ExitType, ExitTypeLabel, PartyVariant} from "../../utils/enums";
import {createOptions, Date, Enums, resolveApiResult, validateAddress} from "../../utils";
import {showModal} from "../../actions/modal";
import {loadExit, saveExit} from "../../actions/exits";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormButtons, renderItemFormFiles} from "./helpers";
import {loadFiles, saveFile} from "../../actions/files";
import PartyField from "../form/PartyField";
import {renderDateField} from "../form/DateField";

const validate = (values) => {
	const errors = {};
	if (!values.exitType) {
		errors.exitType = 'Zvolte prosím typ';
	} else {
		if (!values.exitAt) {
			errors.exitAt = 'Zvolte prosím datum a čas';
		}
		switch (values.exitType) {
			case ExitType.RE:
				if (!values.partyId) {
					errors.partyId = 'Vyberte prosím';
				}
				if (!values.ownerProof) {
					errors.ownerProof = 'Uveďte prosím doklad';
				}
				if (!values.contractDate) {
					errors.contractDate = 'Zadejte prosím datum smlouvy'
				}
				break;

			case ExitType.AN: // new
			case ExitType.AS: // subsidiary
			case ExitType.AT: // temporary
			case ExitType.AO: // org
				if (!values.partyId) {
					errors.partyId = 'Vyberte prosím';
				}
				if (!values.contractDate) {
					errors.contractDate = 'Zadejte prosím datum smlouvy'
				}
				validateAddress(values, 'animalAddress', errors, true);
				break;

			case ExitType.DE:
			case ExitType.ES:
			case ExitType.TH:
				if (!values.exitDesc) {
					errors.exitDesc = 'Uveďte prosím popis';
				}
				break;

			default:
		}
	}

	if (!values.exitTitle) {
		errors.exitTitle = 'Uveďte prosím název léku';
	}

	return errors
}

const textual = (item) => {
	return ExitTypeLabel[item.exitType] + ' ' + Date.formatDate(item.exitAt) + ' (ID ' + item.exitId + ')';
}

export const createExitInitialValues = (exitId, dogId, session) => {
	return exitId
		? {dogId, exitId}
		: {
			dogId,
			exitDate: Date.format(Date.today(), Date.ISO_DATE_TIME),
			contractLocation: DEFAULT_CONTRACT_LOCATION,
			exitBy: session.user.userId
		};
}

class ExitForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			exitType: null,
			partyInfo: null,
			animalAddress: null
		}

		this.handleSave = this.handleSave.bind(this);

		this.ctx = {
			itemTag: 'Výdej',
			itemKeyName: 'exitId',
			saveItem: props.saveExit,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, props)
		}
	}

	componentWillMount() {
		const {exit} = this.props;
		if (exit.exitId) {
			this.props.loadExit(exit.exitId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
			this.props.loadFiles({exitId: exit.exitId, statuses: [BaseStatus.ACTIVE]}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		} else {
			this.syncEnumsAndState(exit);
		}
	}

	syncEnumsAndState(exit) {
		this.setState({
			exitType: exit == null ? null : exit.exitType,
			animalAddress: exit == null ? null : exit.animalAddress,
		});
	}

	handleSave(values) {
		const v = {...values};
		if (v.contractLocation === DEFAULT_CONTRACT_LOCATION && !v.contractDate) {
			v.contractLocation = null;
		}
		return handleItemSave(this.ctx, v);
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			{(!item || isFetchingItem) ? null : this.renderForm()}
		</Modal>
	}

	getPartyField(exitType) {
		return <Field key={'partyId'} label={ExitPartyLabel[exitType]} name="partyId"
			variant={exitType === ExitType.AO ? PartyVariant.EXIT_ORG : PartyVariant.EXIT_PARTY}
			component={PartyField} clearable={true}
			onOptionInfoHook={(info) => {
				this.setState({partyInfo: info})
			}}/>
	}

	renderForm() {
		const {entity: {item}, initialValues, handleSubmit, dog, enums} = this.props;
		const {exitType, animalAddress, partyInfo} = this.state;

		const rows = [];

		switch (exitType) {
			case ExitType.DE:
			case ExitType.ES:
			case ExitType.TH:
				break;

			default:
				rows.push(this.getPartyField(exitType));
		}

		let exitReasonLabel;
		let exitByLabel = 'Předal';
		let exitAtTitle = 'Datum a čas výdeje zvířete z útulku'
		let hasContract = true;
		switch (exitType) {
			case ExitType.RE: // return
				rows.push([
					<Row key={'ownerProof'}>
						<Col sm={12}>
							<Field label={'Doklad o vlastnictví'} name={"ownerProof"} type="text" component={TextareaField} rows={1}
								quickValues={['Číslo čipu', 'Fotografie', 'Smlouva', 'Očkovací průkaz']}/>
						</Col>
					</Row>,
				]);
				break;

			case ExitType.AN: // new
			case ExitType.AS: // subsidiary
			case ExitType.AT: // temporary
				rows.push([
					<Row key={'isGdprPhoto'}>
						<Col sm={10} smOffset={2}>
							<Field label={'Souhlas s použitím fotografie'} name={"isGdprPhoto"} component={CheckboxField}/>
						</Col>
					</Row>,
					<Row key={'documents'}>
						<Col sm={12}>
							<Field label={'Předané dokumenty'} name={"documents"} type="text" component={TextareaField}
								quickValues={['Zdravotní karta', 'Karta čipu', 'Očkovací průkaz']}/>
						</Col>
					</Row>,
					<Row key={'animalAddress'}>
						<h5 className="divider">Adresa pobytu zvířete</h5>
						<Col sm={6}>
							<Field label={'Ulice'} name="animalAddress[street]" type='text' component={TextField} maxLength="100" onChangeHook={(v) => {
								let a = animalAddress || {};
								a.street = v;
								this.setState({animalAddress: a});
							}}/>
						</Col>
						<Col sm={6}>
							<Row>
								<Col sm={7}>
									<Field label={'Město'} name="animalAddress[city]" type='text' sizes={[3, 9]} component={TextField} maxLength="100" onChangeHook={(v) => {
										let a = animalAddress || {};
										a.city = v;
										this.setState({animalAddress: a});
									}}/>
								</Col>
								<Col sm={5}>
									<Field label={'PSČ'} name="animalAddress[zip]" type='text' sizes={[3, 9]} component={TextField} maxLength="6" onChangeHook={(v) => {
										let a = animalAddress || {};
										a.zip = v;
										this.setState({animalAddress: a});
									}}/>
								</Col>
							</Row>
						</Col>
						<Col sm={12}>
							{partyInfo && partyInfo.permAddress && partyInfo.permAddress.street
								&& JSON.stringify(partyInfo.permAddress) !== JSON.stringify(animalAddress)
								&& <button className={'btn btn-secondary btn-quick btn-xs pull-right'} onClick={(e) => {
									e.preventDefault();
									this.props.change('animalAddress[street]', partyInfo.permAddress.street);
									this.props.change('animalAddress[city]', partyInfo.permAddress.city);
									this.props.change('animalAddress[zip]', partyInfo.permAddress.zip);
									this.setState({animalAddress: {...partyInfo.permAddress}});
								}}>
									{partyInfo.permAddress.street + ', ' + partyInfo.permAddress.city + ', ' + partyInfo.permAddress.zip}
								</button>}
						</Col>
					</Row>,
				]);
				break;

			case ExitType.AO:
				rows.push(<Row key={'documents'}>
					<Col sm={12}>
						<Field label={'Předané dokumenty'} name={"documents"} type="text" component={TextareaField}
							quickValues={['Zdravotní karta', 'Karta čipu', 'Očkovací průkaz']}/>
					</Col>
				</Row>);
				break;

			case ExitType.DE:
				rows.push(<Row key={'exitCause'}>
						<Col sm={12}>
							<Field label={'Příčina'} name={"exitCause"} type="text" component={TextareaField}/>
						</Col>
					</Row>,
					<Row key={'exitDesc'}>
						<Col sm={12}>
							<Field label={'Poznámka'} name={"exitDesc"} type="text" component={TextareaField}/>
						</Col>
					</Row>);
				hasContract = false;
				exitByLabel = null;
				exitAtTitle = 'Datum a čas úmrtí';
				break;

			case ExitType.ES:
			case ExitType.TH:
				rows.push(<Row key={'exitDesc'}>
						<Col sm={12}>
							<Field label={'Poznámka'} name={"exitDesc"} type="text" component={TextareaField}/>
						</Col>
					</Row>);
				hasContract = false;
				exitByLabel = null;
				exitAtTitle = null;
				break;

			default:
				break;
		}

		if (hasContract) {
			rows.push([
				<Row key={'contractHeader'}><h5 className="divider">Smlouva</h5></Row>,
				<Row key={'contract'}>
					<Col sm={6}>
						<Field label={'Místo'} name={"contractLocation"} component={TextField} maxLength={100}/>
					</Col>
					<Col sm={6}>
						<Field label={'Datum sml.'} name={"contractDate"} type="text" component={DateField} maxLength="12"
							maxDate={Date.today()}/>
					</Col>
				</Row>
			]);
		}

		if (exitReasonLabel) {
			rows.push(<Row key={'exitReason'}>
				<Col sm={12}>
					<Field label={exitReasonLabel} name={"exitReason"} type="text" component={TextareaField}/>
				</Col>
			</Row>);
		}

		if (exitType === ExitType.AT) {
			rows.push(<Row key={'tempEquip'}>
				<Col sm={12}>
					<Field label={'Zapůjčené příslušenství'} name={"tempEquip"} type="text" component={TextareaField}/>
				</Col>
			</Row>);
		}

		rows.push([
			<Row key={'exitBy'}>
				{exitByLabel && <h5 className={'divider'}>Výdej</h5>}
				{exitByLabel && <Col sm={6}>
					<Field label={exitByLabel} name={"exitBy"} component={SelectField} options={Enums.createEnumItems(enums, 'user')}/>
				</Col>}
				<Col sm={6}>
					{renderDateField({
						label: 'Datum a čas', title: exitAtTitle, name: "exitAt", maxDate: Date.today(),
						clearable: true, withTime: true
					})}
				</Col>
			</Row>
		]);

		if (exitType === ExitType.AT) {
			rows.push(<Row key={'tempTo'}>
				<Col sm={12}>
					<Field label={'Dočasná péče ukončena'} name={"tempTo"} type="text" component={DateField} maxLength="12"
						maxDate={Date.today()} sizes={[8, 4]}/>
				</Col>
			</Row>);
		}

		let title;
		if (dog && dog.dogId) {
			if (initialValues.exitId) {
				title = <span>Úprava výdeje <Badge pullRight>{initialValues.exitId}</Badge></span>;
			} else {
				title = 'Nový výdej';
			}
			if (dog.name) {
				title = <span>{dog.name} - {title}</span>;
			}
		} else {
			title = 'Výdej zvířete';
		}

		return <Form horizontal onSubmit={handleSubmit(this.handleSave)} className="detail">
			<Modal.Header>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row key={'exit'}>
					<Col sm={6}>
						<Field label={'Typ'} name={"exitType"} component={SelectField} options={createOptions(ExitTypeLabel)}
							onChangeHook={(exitType) => this.setState({exitType})}/>
					</Col>
				</Row>
				{exitType && rows}
				{exitType && renderItemFormFiles(this.state.currentFiles)}
			</Modal.Body>
			<Modal.Footer>
				{renderItemFormButtons(this.ctx, item, this.props)}
			</Modal.Footer>
		</Form>
	}
}

ExitForm = reduxForm({
	enableReinitialize: true,
	form: 'exit',
	validate
})(ExitForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {exits, dogs, parties},
		enums,
		session
	} = state;

	const form = state.form['exit'];
	const {exit} = ownProps;

	const dog = ((dogs[exit.dogId] ? dogs[exit.dogId].item : exit.dog) || exit.dog) || {};
	const party = ((parties[exit.partyId] ? parties[exit.partyId].item : exit.party) || exit.party) || {};

	const entity = exit.exitId && exits[exit.exitId]
		? exits[exit.exitId]
		: {
			...defaultState,
			item: (form || {}).initial || (exit.exitId ? null : {...exit})
		};

	return {
		entity,
		initialValues: entity.item,
		dog,
		party,
		enums,
		session
	}
}

ExitForm.propTypes = {
	dog: PropTypes.object,
	exit: PropTypes.object.isRequired,
	party: PropTypes.object,
	loadExit: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveExit: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadExit,
	loadFiles,
	saveExit,
	saveFile,
	showMessage,
	showModal
})(ExitForm)



// WEBPACK FOOTER //
// ./src/components/dog/ExitForm.js